(function($) {
  $('.navHamburger').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $('#top-navigation').toggleClass('open');
  });
  $('.dropdown-toggle').on('click', function(e){
    if ($(this).next().is(':visible')) {
      location.href = $(this).attr('href');;
    }
  });
})(jQuery);
